import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../components/LoginForm.css';
import { authService } from '../authService';
import logoImage from '../../../assets/Icon/image.png';

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState('');
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage('');
    setError('');
    try {
      const res = await authService.forgotPassword(email);
      setMessage('Password reset instructions sent to your email.');
    } catch (err) {
      setError(err?.response?.data?.message || 'Failed to send reset instructions.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-root">
      <div className="login-left">
      <img 
          src={logoImage} 
          alt="Aesop Pricing Logo" 
          style={{ 
            width: '120px', 
            height: 'auto', 
            marginBottom: '20px',
            display: 'block'
          }} 
        />
        <h1 className="login-title">Hello,<br/>AESOP PRICING!</h1>
        <p className="login-desc">
          Lorem ipsum dolor sit amet consectetur. Aliquam tortor fermentum egestas id pellentesque mi nec nibh amet. Congue laoreet commodo dui tempor venenatis vitae.
        </p>
        <div className="login-footer-text">2025 AESOP. All rights reserved.</div>
      </div>
      <div className="login-right">
        <div className="login-card">
          <div style={{display:'flex', flexDirection:'column', alignItems:'center', marginBottom: 24}}>
            <div className="forgot-icon" style={{background:'#fff', borderRadius:16, padding:16, marginBottom:16}}>
              <span role="img" aria-label="fingerprint" style={{fontSize:40}}>🔒</span>
            </div>
            <h2 className="login-header-title">Forgot Password?</h2>
            <p className="login-header-desc">No worries, we'll send you reset instructions.</p>
          </div>
          <form onSubmit={handleSubmit}>
            {message && <div style={{color: 'green', marginBottom: 12}}>{message}</div>}
            {error && <div style={{color: 'red', marginBottom: 12}}>{error}</div>}
            <input
              type="email"
              className="login-input"
              placeholder="Enter Your Mail"
              value={email}
              onChange={e => setEmail(e.target.value)}
              required
              style={{marginBottom: 24}}
              disabled={loading}
            />
            <button type="submit" className="login-button" style={{width:'100%'}} disabled={loading}>
              {loading ? 'Submitting...' : 'Submit'}
            </button>
          </form>
          <div className="login-footer-link" style={{marginTop: 24, textAlign:'center'}}>
            Know your password?{' '}
            <span className="login-link" onClick={() => navigate('/login')} style={{cursor:'pointer', color:'#222', fontWeight:600}}>Go to Login</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordPage; 